import request from "./index";

export const History = {
  GetInternalChatList: (data) => {
    return request.post("/api/History/GetInternalChatList", data);
  },
  GetInternalChatDeatil: (data) => {
    return request.post("/api/History/GetInternalChatDeatil", data);
  },
  GetClientChatList: (data) => {
    return request.post("/api/History/GetClientChatList", data);
  },
  ClientChatKeyWordList: (data) => {
    return request.post("/api/History/ClientChatKeyWordList", data);
  },
  GetClientChatDeatil: (data) => {
    return request.post("/api/History/GetClientChatDeatil", data);
  },
  ExportClientChat: (data, config) => {
    return request.post("/api/History/ExportClientChat", data, config);
  },
  ExportClientChatToPDF: (data, config) => {
    return request.post("/api/History/ExportClientChatToPDF", data, config);
  },
  ExportInternalChat: (data, config) => {
    return request.post("/api/History/ExportInternalChat", data, config);
  },
  ExportClientChatKeyWord: (data, config) => {
    return request.post("/api/History/ExportClientChatKeyWord", data, config);
  },
  GetVideoCallList: (data) => {
    return request.post("/api/History/GetVideoCallList", data);
  },
  GetVideoCallDetail: (data) => {
    return request.post("/api/History/GetVideoCallDetail", data);
  },
};
